type FacebookPixel = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[];
  push?: unknown;
  loaded?: boolean;
  version?: string;
};

declare global {
  interface Window {
    fbq?: FacebookPixel;
    _fbq?: FacebookPixel;
  }
}

const pixelId = "2333344460802197";
let initialized = false;

function ensurePixelQueue(): FacebookPixel | null {
  if (typeof window === "undefined" || typeof document === "undefined") return null;
  if (window.fbq) return window.fbq;

  const fbq: FacebookPixel = function (...args: unknown[]) {
    if (fbq.callMethod) {
      fbq.callMethod(...args);
      return;
    }
    fbq.queue?.push(args);
  } as FacebookPixel;

  fbq.queue = [];
  fbq.loaded = true;
  fbq.version = "2.0";
  fbq.push = fbq;

  window.fbq = fbq;
  window._fbq = fbq;

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(script);

  return fbq;
}

export function initializeMetaPixel() {
  if (initialized) return;

  const fbq = ensurePixelQueue();
  if (!fbq) return;

  fbq("init", pixelId);
  fbq("track", "PageView");
  initialized = true;
}

export function trackCheckoutIntent() {
  if (typeof window === "undefined" || !window.fbq) return;

  window.fbq("track", "InitiateCheckout", {
    content_name: "+100 Ensaladas para Bajar de Peso",
    value: 19990,
    currency: "ARS",
  });
}
